import { z } from 'zod';

export const BizyOnboarding = z.object({
	onboardingStage: z.number().int(),
});

export type BizyOnboarding = z.infer<typeof BizyOnboarding>;

export const bizyOnboardingFixture = (overrides: Partial<BizyOnboarding> = {}): BizyOnboarding => ({
	onboardingStage: 0,
	...overrides,
});

export const BizyOnboardingFact = z.object({
	id: z.string(),
	fact: z.string(),
});

export type BizyOnboardingFact = z.infer<typeof BizyOnboardingFact>;

export const BizyOnboardingFacts = z.object({
	facts: z.array(BizyOnboardingFact),
});

export type BizyOnboardingFacts = z.infer<typeof BizyOnboardingFacts>;

export const bizyOnboardingFactsFixture = (overrides: Partial<BizyOnboardingFacts> = {}): BizyOnboardingFacts => ({
	facts: [{ id: 'fact-1', fact: 'You joined 3 years ago.' }],
	...overrides,
});
